import { getData } from '../../api/api'
export function GetDashboardDetails (data) {
  return new Promise((resolve, reject) => {
    getData('Logistics/GetDashboardDetails', data).then(response => {
      resolve(response)
    })
  })
}
